import { put, takeLatest, call } from 'redux-saga/effects';
import types from '../../types';
import api from '../../../services/api';
import notification from '../../../services/notification';

function* getUserLoginHistory({ payload }) {
  try {
    const { data, status } = yield call(api.profile.getUserLoginHistory, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_USER_LOGIN_HISTORY_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_USER_LOGIN_HISTORY_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

export function* userLoginHistory() {
  yield takeLatest(types.GET_USER_LOGIN_HISTORY_START, getUserLoginHistory);
}
